import { bl_fi_mst_entity_conglomerate_hdr_RowClass } from '../../../dbschema/bl_fi_mst_entity_conglomerate_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class ConglomerateContainerModel extends BaseContainerModel{
    bl_fi_mst_entity_conglomerate_hdr: bl_fi_mst_entity_conglomerate_hdr_RowClass = new bl_fi_mst_entity_conglomerate_hdr_RowClass();
}